import deMessages from "../../../../../assets/i18n/es.json";
import * as _ from 'lodash';
import { Component, enableProdMode, ViewContainerRef, ViewChild } from '@angular/core';
import { DxSchedulerComponent } from 'devextreme-angular';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { locale, loadMessages } from "devextreme/localization";
import notify from 'devextreme/ui/notify';
import { baseZIndex } from 'devextreme/ui/overlay';
import moment from 'moment';
import { IAppointment, SAppointment } from '../../../tasks-page/tasks/appoinment/appointment.interface';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { ITask, ITaskAppointmentFilter } from '../../../tasks-page/tasks/task.interface';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { AppointmentsService } from '../../../tasks-page/tasks/appoinment/appointment.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { FeaturesService } from '../../../features-page/features/features.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { SETTINGS } from "../../../settings-page/settings/settings.constants";
import { TaskSingleComponent } from "../../../tasks-page/tasks/task-single/task-single.component";


let self: any;

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

@Component({
  selector: 'app-calendar-by-worker',
  templateUrl: './calendar-by-worker.component.html',
  styleUrls: ['./calendar-by-worker.component.css'],
  providers: [],
})
export class CalendarByWorkerComponent {
  @ViewChild(DxSchedulerComponent) scheduler!: DxSchedulerComponent;
  appointmentsData: SAppointment[] = [];
  workers: IWorker[] = [];
  workersV: any[] = [];
  appointments: IAppointment[] = [];
  selectedTask: ITask = {};
  filter: ITaskAppointmentFilter = {
    sort: '',
    skip: 0,
    limit: 5000,
    filters: {
      //startDate: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
      //endDate: new Date(new Date().setHours(23, 59, 59, 999)).toISOString()
      filterDate: new Date().toISOString()
    },
  };
  loadingVisible = true;
  getMore: boolean = false;
  currentDate: Date = new Date();
  formItems = [];
  formOpening: any;
  settings: any = [];
  feature: any = [];

  form!: UntypedFormGroup;
  formC!: UntypedFormGroup;
  workersF: IWorker[] = [];
  workersFilter!: [];
  clients: IClient[] = [];
  clientsFilter: "" | undefined;
  submitted = false;
  statusFilter: string = "";
  colorStatusOpen: string = "";
  colorStatusScheduled: string = "";
  colorStatusInvoiced: string = "";
  colorStatusOnGoing: string = "";
  colorStatusCompleted: string = "";
  colorStatusCancelled: string = "";
  selectedMonth: number = new Date().getMonth();
  countWeek: number = 0;
  constructor(
    private _AppointmentService: AppointmentsService,
    private _WorkersService: WorkersService,
    private _ClientsService: ClientsService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService,
    private _SettingsService: SettingsService,
    private _FeaturesService: FeaturesService,
    private _dialogService: DialogService,
    private fb: UntypedFormBuilder
  ) {
    self = this;
    loadMessages(deMessages);
    locale(navigator.language);
  }

  ngOnInit() {
    this.filter.company = this._AuthService.companyId();
    baseZIndex(900);


    this._FeaturesService.getFeatures({ filters: { name: "Agenda" } }).subscribe((feature) => {
      this.feature = feature;
      this._SettingsService.getCompanySettingByFeature({ company: this._AuthService.companyId(), filters: { feature: feature[0]["_id"] } }).subscribe((settings) => {
        this.settings = settings;
        this.setStatusColor();
      });
    });

    this._WorkersService.getWorkers({ limit: 500, skip: 0, company: this._AuthService.companyId(), filters: { isDeleted: false } }).subscribe((workers) => {
      this.workers = workers;
      this.workers = _.orderBy(this.workers, ['firstname', 'lastname'], ['asc', 'asc']);
      this.workers.forEach((a) => {
        let firstname = a.firstname ?? "";
        let lastname = a.lastname ?? "";
        this.workersV.push({
          id: a._id,
          text: firstname + "\n" + lastname
        });
      })
      setTimeout(() => {
        this.loadingVisible = false;
        this.getAppointments();
      }, 1200);

    });

    this._ClientsService.getClients({ limit: 500, skip: 0, company: this._AuthService.companyId(), filters: { isDeleted: false } }).subscribe((clients) => {
      this.clients = clients;
      this.clients = _.orderBy(this.clients, ['firstname'], ['asc']);
    });

    this.buildForm();

  }

  ngOnDestroy() {
    this.scheduler.instance.dispose();
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      workers: [],
    });
    this.formC = this.fb.group({
      clients: [],
    });
  }

  onSubmit() {
    this.submitted = true;
    this.filterAppointments();
  }

  resetFilter() {
    const filter: any = this.filter;
    filter.filters.workers = [];
    this.workersFilter = [];
    this.appointments = [];
    this.workersV = [];

    this.workers.forEach((a) => {
      let firstname = a.firstname ?? "";
      let lastname = a.lastname ?? "";
      this.workersV.push({
        id: a._id,
        text: firstname + "\n" + lastname
      });
    });
    notify(`Cargando...` + '', "info", 800);
    setTimeout(() => {
      this.getAppointments();
      this.scheduler.instance.getDataSource().reload();
      this.scheduler.instance.repaint();
    }, 500)
  }

  resetFilterC() {
    //this.filter.filters.client = "";
    this.clientsFilter = "";
    this.appointments = [];
    notify(`Cargando...` + '', "info", 800);
    this.getAppointments();
  }

  calculateDayFilter(e = new Date()) {
    const filter: any = this.filter;
    filter.filters.filterDate = e.toISOString();
    delete filter.filters.startDate;
    delete filter.filters.endDate;
  }

  getAppointments(e?: any) {
    if (e) {
      this.calculateDayFilter(e)
    };
    this.appointmentsData = [];

    this._AppointmentService.getAppointments(this.filter).subscribe((appointments: any) => {
      this.appointments = _.concat(this.appointments, appointments);
      this.appointments.forEach((a) => {
        let cTitle = (a.task.title != null) ? (a.category[0].name + " | " + a.task.title) : a.category[0].name;
        this.appointmentsData.push({
          text: a.title ?? "",
          startDate: new Date(a.startDate || ''),
          endDate: new Date(a.endDate || ''),
          color: this.getColor(a.task['status']),
          task: a.task,
          client: a.client,
          worker: a.task.workers ?? null,
          cTitle: cTitle,
        })
      });
      //this.getMore = appointments.length >= this.filter.limit ? true : false;
    });

  }

  getColor(status: any) {
    switch (status) {
      case 'OPEN':
      case 'QUOTED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_OPEN_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'ONGOING': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_ONGOING_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'SCHEDULED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_SCHEDULED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'INVOICED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_INVOICED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'COMPLETED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_COMPLETED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      case 'CANCELLED': {
        let value = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_CANCELLED_COLOR);
        return value[0].companySetting != null ? value[0].companySetting.value : value[0].defaultValue;
      }
      default: {
        break;
      }
    }
  }

  setStatusColor() {
    let open = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_OPEN_COLOR);
    this.colorStatusOpen = open[0].companySetting != null ? open[0].companySetting.value : open[0].defaultValue;

    let scheduled = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_SCHEDULED_COLOR);
    this.colorStatusScheduled = scheduled[0].companySetting != null ? scheduled[0].companySetting.value : scheduled[0].defaultValue;

    let invoiced = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_INVOICED_COLOR);
    this.colorStatusInvoiced = invoiced[0].companySetting != null ? invoiced[0].companySetting.value : invoiced[0].defaultValue;

    let ongoing = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_ONGOING_COLOR);
    this.colorStatusOnGoing = ongoing[0].companySetting != null ? ongoing[0].companySetting.value : ongoing[0].defaultValue;

    let completed = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_COMPLETED_COLOR);
    this.colorStatusCompleted = completed[0].companySetting != null ? completed[0].companySetting.value : completed[0].defaultValue;

    let cancelled = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_CANCELLED_COLOR);
    this.colorStatusCancelled = cancelled[0].companySetting != null ? cancelled[0].companySetting.value : cancelled[0].defaultValue;
  }

  loadMore() {
    if (this.getMore && !this.loadingVisible) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getAppointments();
    }
  }

  filterAppointments() {
    const filter: any = this.filter;
    filter.filters.workers = this.workersFilter;
    //this.filter.filters.client = this.clientsFilter;
    filter.filters.status = this.statusFilter;
    if (this.workersFilter.length > 0) {
      this.workersV = [];
      this.workers.forEach((a) => {
        let firstname = a.firstname ?? "";
        let lastname = a.lastname ?? "";
        this.workersV.push({
          id: a._id,
          text: firstname + "\n" + lastname
        });
      });
      this.workersV = this.workersV.filter(item => filter.filters.workers.includes(item.id));
    }
    notify(`Cargando...` + '', "info", 800);
    setTimeout(() => {
      this.appointments = [];
      this.getAppointments();
      this.scheduler.instance.getDataSource().reload();
    }, 1000)
  }

  showToast(event: any, value: any, type: any, time = 800) {
    notify(`${event} "${value}"` + ' task', type, time);
  }

  onOptionChanged(e: any) {

    if (e.component.option('currentView') == 'timelineDay') {
      try {
        var curr = e.value;
        if (curr instanceof Date) {
          notify(`Cargando...` + '', "info", 800);
          setTimeout(() => {
            this.appointments = [];
            this.getAppointments(curr);
            this.scheduler.instance.getDataSource().reload();
            //e.component.scrollToTime(curr.getHours(), 0, curr.getDate());
          }, 500);
        }
      } catch (e) {

      }
    }

    if (e.component.option('currentView') == 'week' && e.name == 'selectedCellData') {

      try {

        var firstday = new Date(e.component.getStartViewDate());
        var lastday = new Date(e.component.getEndViewDate());

        const filter: any = this.filter;

        //refactor
        if (firstday.getDate() == lastday.getDate()) {
          filter.filters.startDate = new Date(firstday.setDate(firstday.getDate() - 7)).toISOString();
          filter.filters.endDate = new Date(lastday.setDate(lastday.getDate() + 7)).toISOString();
        } else {
          filter.filters.startDate = moment(firstday).subtract(14, 'days').toISOString();
          filter.filters.endDate = moment(lastday).add(14, 'days').toISOString();
        }

        delete filter.filters.filterDate;

        notify(`Cargando...` + '', "info", 800);
        setTimeout(() => {
          this.appointments = [];
          this.getAppointments();
          this.scheduler.instance.getDataSource().reload();
          //e.component.scrollToTime(7, 0, curr.getDate());
        }, 1000);

      } catch (e) {

      }

    }

    if (e.name == 'currentDate' && e.component.option('currentView') == 'Día') {
      try {
        var curr = e.value;
        if (curr instanceof Date) {
          notify(`Cargando...` + '', "info", 800);
          setTimeout(() => {
            this.appointments = [];
            this.getAppointments(curr);
            this.scheduler.instance.getDataSource().reload();
            //e.component.scrollToTime(7, 0, curr.getDate());
          }, 500);
        }
      } catch (e) {

      }
    }

  }


  onContentReady(e: any) {
    let hours = new Date().getHours();
    if (e.component.option('currentView') == 'timelineDay') {
      setTimeout(() => {
        e.component.scrollToTime(hours, 0, undefined);
      }, 1000);
    }

  }

  onAppointmentFormOpening(e: any) {

    const that = this;
    e.popup.option('showTitle', true);
    e.popup.option('title', e.appointmentData.text ?
      e.appointmentData.text :
      'cita');

    let form = e.form;
    this.formOpening = form;
    let formItems = form.option('items');

    this.formItems = formItems;

    if (e.appointmentData.task != undefined) {
      this.selectedTask = e.appointmentData.task;
    } else {
      this.selectedTask = {};
    }

    if (e.appointmentData.task != undefined) {
      this.openEditTaskModal();
    }

  }

  openEditTaskModal() {
    this.openTasksModalEdit(this.selectedTask);
  }

  openTasksModalEdit(task?: ITask, readOnly: boolean = false) {

    setTimeout(() => {
      //cochino pero funciona
      let element = document.getElementsByClassName('dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-popup-cancel')[0];
      element.setAttribute('id', 'btn-close');
      document.getElementById('btn-close')?.click();
    });

    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.panelClass = 'calendar-task';
    config.viewContainerRef = this._viewContainerRef;
    config.disableClose = true;
    config.hasBackdrop = true;
    self.dialogRef = this._dialog.open(TaskSingleComponent, config);
    self.dialogRef.componentInstance.task = task;
    // self.dialogRef.componentInstance.readOnly = readOnly;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showStart = true;
    self.dialogRef.componentInstance.showEnd = true;
    self.dialogRef.afterClosed().subscribe((result: any) => {
      if (this.selectedTask._id != undefined && result._id != undefined) {
        this.selectedTask = result;
      }
      if (result._id != undefined) {
        this.selectedTask = result;
      }
      self.dialogRef = null;
    });
    self.dialogRef.backdropClick().subscribe(() => {
      self.dialogRef = null;
      setTimeout(() => {
        //cochino pero funciona
        let element = document.getElementsByClassName('dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-popup-cancel')[0];
        element.setAttribute('id', 'btn-close');
        document.getElementById('btn-close')?.click();
      });
    });
  }

}

